/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * What the edit targets: 'series' = the whole rule / one-off; 'occurrence' = a single date (requires occurrenceDate); 'thisAndFollowing' = split the rule at occurrenceDate.
 */
export enum UpdateSlotBodyScope {
  series = 'series',
  occurrence = 'occurrence',
  thisAndFollowing = 'thisAndFollowing'
}
